<!-- 입대업체 그룹을 수정하거나 등록하는 팝업입니다. -->
<template>
  <div style="height: 100%; border: 1px solid #9e9e9e; overflow-y: auto">
    <!-- 테이블 표시 제목입니다. -->
    <div class="name_header">
  <span style="font-size: 20px; font-weight: bold">
      {{ title }}
    </span>
      <span>
     <button class="button_size" @click="load(item)">
                        <v-icon color="white"
                        >mdi-refresh</v-icon>
     </button>
</span>
    </div>
    <div
        v-if="loading"
        class="loading-overlay d-flex justify-center align-center"
    >
      <v-progress-circular
          size="30"
          color="primary"
          style="z-index: 1000"
          indeterminate
      ></v-progress-circular>


    </div>
    <div v-else class="d-flex justify-space-around px-10 pt-5">

      <div style="width: 50%" class="px-2">
        <span class="sub_text">
          미등록 업체
        </span>
        <table class="table-wrap mt-1 ">
          <thead>
          <tr>
            <th>
              임대업체 ID
            </th>
            <th>
              임대업체 명
            </th>
            <th>
              추가
            </th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="item in addableList" :key="'td-'+item.rentalcompanyId"
              :class="item.selected ? 'selected-row' : undefined"
          >
            <td :title="item.rentalcompanyName">
              {{ item.rentalcompanyId }}
            </td>
            <td :title="item.rentalcompanyName">
              {{ item.rentalcompanyName }}
            </td>
            <td>
              <button class="button_size" :disabled="isDisable" @click="assign(item)">
                <v-icon color="#0C98FE">
                  mdi-plus
                </v-icon>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div style="width: 50%" class="px-2">
        <span class="sub_text">
          등록 업체
        </span>

        <table class="table-wrap mt-1 ">
          <thead>
          <tr>
            <th>
              임대업체 ID
            </th>
            <th>
              임대업체 명
            </th>
            <th>
              제거
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in addedList" :key="'td-'+item.rentalcompanyId"
              :class="item.selected ? 'selected-row' : undefined"
              class="table-row"

          >
            <td :title="item.rentalcompanyName">
              {{ item.rentalcompanyId }}
            </td>
            <td :title="item.rentalcompanyName">
              {{ item.rentalcompanyName }}
            </td>
            <td>
              <button class="button_size" :disabled="isDisable" @click="unAssign(item)">
                <v-icon color="#0C98FE">
                  mdi-minus
                </v-icon>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>

</template>

<script>
import {PATH} from "@/constants";

export default {
  name: "AgencyManagerMoveComponent",
  components: {},

  props: {
    // 담당자 정보
    item: {
      type: Object,
      default: undefined
    },
  },

  data() {
    return {
      loading: false,
      isDisable: false,
      addableList: [],
      addedList: [],
      itemLoading: false,
    }
  },

  computed: {
    title() {
      if (this.item) {
        return this.item.name
      } else {
        return '선택되지 않음'
      }
    }
  },

  watch: {
    item: {
      handler(newValue) {
        this.load(newValue)
      }
    },
  },

  methods: {
    addItem(item) {
      for (let i = 0; i < this.addableList.length; i++) {
        if (this.addableList[i] === item) {
          this.addableList.splice(i, 1);
          i--;
        }
      }
      this.addedList.push(item)
    },
    removeItem(item) {
      for (let i = 0; i < this.addedList.length; i++) {
        if (this.addedList[i] === item) {
          this.addedList.splice(i, 1);
          i--;
        }
      }
      this.addableList.push(item)
    },
    async assign(item) {
      this.isDisable = true
      await this.$request(`${PATH.AGENCY_MANAGER.ASSIGN}/${this.item.amUserId}/${item.rentalcompanyId}`)
          .get()
          .enqueue()
          .then(() => {
            this.addItem(item)
            this.$toasted.success('추가에 성공했습니다.')
            this.isDisable = false
          })
    },
    async unAssign(item) {
      this.isDisable = true
      await this.$request(`${PATH.AGENCY_MANAGER.UN_ASSIGN}/${this.item.amUserId}/${item.rentalcompanyId}`)
          .get()
          .enqueue()
          .then(() => {
            this.removeItem(item)
            this.$toasted.success('제거에 성공했습니다.')
            this.isDisable = false
          })
    },
    async load(item) {
      if (!item) return this.$toasted.error('담당자를 선택해주세요.');
      try {
        this.loading = true
        const params = {
          ...item
        }
        const res = await this.$request(PATH.AGENCY_MANAGER.COMPANY_LIST)
            .setObject(params)
            .enqueue()
        this.addableList = res.addableList
        this.addedList = res.addedList

      } finally {
        this.loading = false
      }

    },
  },
}
</script>

<style scoped>
.loading-overlay {
  position: relative;
  height: 70%;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  display: none;
  flex-direction: column;
}
.name_header {
  position: relative;
  height: 50px;
  padding: 1rem;
  color: white;
  background: #818181;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-wrap {
  width: 100%;
  border-bottom: 1px solid #ddd;
  border-spacing: 0;
}

.table-wrap th:nth-child(1) {
  width: 90px;
}

.table-wrap th:nth-child(3) {
  width: 50px;
}

.table-wrap th {
  background: #f8f8f8;
}

.table-wrap th,
.table-wrap td {
  padding: 7px;
  font-weight: normal;
  text-align: left;
}

.table-wrap th {
  font-weight: bold;
}

.table-wrap td {
  border-top: 1px solid #ddd;
}

.sub_text {
  font-size: 15px;
  font-weight: bold;
}

.button_size {
  width: 30px;
}


.switching-btn {
  padding: 10px
}
</style>
